<template>
  <Screen>
    <AppBar :title="title" :showBackButton="false" />
    <Breadcrumbs :title="title" />
    <iframe :src="url" frameborder="0" class="card card-body p-0"></iframe>
  </Screen>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: "/",
    },
    title: {
      type: String,
      default: "Monitering apps",
    },
  },
  data() {
    return {
      // urls: {
      //   applogs: "/admin/tp-apps/health/app-logs",
      //   health: "/admin/tp-apps/health/telescope",
      //   horizon: "/admin/tp-apps/health/horizon",
      // },
    };
  },
};
</script>
<style lang="scss" scoped>
iframe {
  height: 80vh;
  height: calc(var(--vh, 1vh) * 80);
  width: 100%;
}
</style>